import { ThemeScreenProps } from "../types";
import { resolveColor, MOCK_CATEGORIES, MOCK_ITEMS, DEFAULT_THEME_COLORS } from "../constants";
import {
  CatScreen,
  TopBar,
  SearchBar,
  ClearCartBtn,
  CatBody,
  CatSidebar,
  CategoryCard,
  CategoryEmoji,
  CategoryLabel,
  CatMainContent,
  SectionTitle,
  ItemsGrid,
  ItemCard,
  ItemImagePlaceholder,
  BestSellerBadge,
  CatItemName,
  CatItemDesc,
  CatItemPrice,
} from "../styles";

function CategoriesScreen({ colors }: ThemeScreenProps) {
  const bg = resolveColor(colors.backgroundColor, DEFAULT_THEME_COLORS.backgroundColor);
  // Sidebar/surface are no longer merchant-configurable — fixed neutral,
  // with the accent brand color marking the selected category.
  const sidebarBg = "#ffffff";
  const surfaceBg = "#ffffff";
  const primaryText = resolveColor(colors.primaryTextColor, DEFAULT_THEME_COLORS.primaryTextColor);
  const secondaryText = resolveColor(colors.secondaryTextColor, DEFAULT_THEME_COLORS.secondaryTextColor);
  const accent = resolveColor(colors.secondaryColor, DEFAULT_THEME_COLORS.secondaryColor);
  const sidebarBorder = accent;

  return (
    <CatScreen $bg={bg}>
      <TopBar>
        <SearchBar>
          <span>🔍</span>
          <span>Search for pasta, ice cream, etc...</span>
        </SearchBar>
        <ClearCartBtn $bg={accent}>🗑 Clear Cart</ClearCartBtn>
      </TopBar>

      <CatBody>
        <CatSidebar $bg={sidebarBg}>
          {MOCK_CATEGORIES.map((cat) => (
            <CategoryCard key={cat.id} $selected={cat.selected} $borderColor={sidebarBorder}>
              <CategoryEmoji>{cat.emoji}</CategoryEmoji>
              <CategoryLabel>{cat.label}</CategoryLabel>
            </CategoryCard>
          ))}
        </CatSidebar>

        <CatMainContent>
          <SectionTitle $color={primaryText}>Cups of Pasta</SectionTitle>
          <ItemsGrid>
            {MOCK_ITEMS.map((item) => (
              <ItemCard key={item.id} $bg={surfaceBg}>
                {item.badge && <BestSellerBadge $color={accent}>BEST SELLER</BestSellerBadge>}
                <ItemImagePlaceholder>🍝</ItemImagePlaceholder>
                <CatItemName $color={primaryText}>{item.name}</CatItemName>
                <CatItemDesc $color={secondaryText}>{item.desc}</CatItemDesc>
                <CatItemPrice $color={primaryText}>{item.price}</CatItemPrice>
              </ItemCard>
            ))}
          </ItemsGrid>
        </CatMainContent>
      </CatBody>
    </CatScreen>
  );
}

export default CategoriesScreen;
